import React, { Component } from 'react'
// import LazyImage from 'vanilla-lazyload'

export default class Picture extends Component {

  render() {
    return (
      <div className="picture">
       <img {...this.props} alt={this.props.alt || this.props.src }/>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Picture.js